<div class="du-mail-popup">
  <!-- Header -->
  <div *ngIf="pageType !== 'fullscreen'"
    class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
    <div class="du-mail-popup-header">New Message from Template</div>
    <mat-icon class="du-mail-popUp-close" *ngIf="!emailId" (click)="popUpClose()">close</mat-icon>
  </div>

  <!-- Loading Spinner -->
  <app-progress-indefinite class="progress-indicator" *ngIf="isLoading"></app-progress-indefinite>

  <!-- Main Content -->
  <div class="du-mail-popup-content" [ngClass]="{ 'popup-style': pageType !== 'fullscreen' }" *ngIf="!isLoading">

    <!-- Reply Section -->
    <div class="reply-section" *ngIf="isReplySectionVisible">
      <div [ngClass]="{'fullscreen-style': pageType === 'fullscreen', 'default-style': pageType !== 'fullscreen'}"
        class="du-mail-popup-container">
        <div class="email-dialog">
          <form>
            <div class="email-fields mb-2">
              <!-- To -->
              <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
                <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
                  <span class="text-muted">To &nbsp;|&nbsp;</span>
                  <input matInput type="email" [(ngModel)]="to" name="to" placeholder="Enter recipient email"
                    class="to-input" />
                </div>
                <div class="right-actions d-flex align-items-center gap-2">
                  <i class="bi bi-person-lines-fill text-primary"></i>
                  <!-- <a href="#" class="text-decoration-none text-primary small"
                    style="font-size:14px;font-weight:500">Contacts</a>
                  <span class="text-muted">|</span> -->
                </div>
              </div>

              <!-- Subject -->
              <div class="form-control d-flex justify-content-between align-items-center subject-field">
                <div class="d-flex align-items-center gap-2 from-to-items-width">
                  <span class="text-muted">Subject</span>
                  <span class="text-muted">&nbsp;|&nbsp;</span>
                  <input matInput type="text" [(ngModel)]="subject" name="subject" placeholder="Enter subject"
                    class="subject-input" />
                </div>
                <a class="text-decoration-none text-primary small"
                  style="cursor:pointer;font-weight:500;font-size:14px;" (click)="openMailTemplates()">Browse
                  templates</a>
              </div>
            </div>

            <!-- Message -->
            <div style="position: relative; height: 100%;">

              <div contenteditable="true" class="email-body" (input)="onMessageInput($event)">
              </div>

            </div>

            <!-- Toolbar & Send -->
            <!-- <div class="toolbar"> -->


              <!-- <div class="uploaded-files" *ngIf="uploadedFiles.length > 0">
                <div *ngFor="let file of uploadedFiles; let i = index" class="file-item">
                  <mat-icon>insert_drive_file</mat-icon>
                  <span>{{ file.name }}</span>
                  <mat-icon class="remove-icon" style="cursor: pointer;" (click)="removeFile(i)">close</mat-icon>
                </div>
              </div> -->

              <div class="actions d-flex justify-content-end" style="margin-top: 15px;">
                <button mat-flat-button color="primary" (click)="sendReply()">
                  <span>Send Reply</span>
                  <mat-icon style="margin-left: 8px;">send</mat-icon>
                </button>
              </div>
            <!-- </div> -->
          </form>
        </div>
      </div>
    </div>

    <!-- Forward Section -->
    <div class="forward-section" *ngIf="isForwardSectionVisible">
      <div [ngClass]="{'fullscreen-style': pageType === 'fullscreen', 'default-style': pageType !== 'fullscreen'}"
        class="du-mail-popup-container">
        <div class="email-dialog">
          <form>
            <div class="email-fields mb-2">
              <!-- To -->
              <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
                <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
                  <span class="text-muted">To &nbsp;|&nbsp;</span>
                  <input matInput type="email" [(ngModel)]="forwardTo" name="forwardTo"
                    placeholder="Enter recipient email" class="to-input" />
                </div>
              </div>

              <!-- Subject -->
              <div class="form-control d-flex justify-content-between align-items-center subject-field">
                <div class="d-flex align-items-center gap-2 from-to-items-width">
                  <span class="text-muted">Subject</span>
                  <span class="text-muted">&nbsp;|&nbsp;</span>
                  <input matInput type="text" [(ngModel)]="forwardSubject" name="forwardSubject"
                    placeholder="Enter subject" class="subject-input" />
                </div>
              </div>
            </div>

            <!-- Forward Body -->
            <textarea matInput rows="6" class="email-body" name="userMessage" [(ngModel)]="userForwardMessage"
              placeholder="Add a message to forward"></textarea>

            <!-- Toolbar & Send -->
            <!-- <div class="toolbar"> -->
              <!-- <div class="uploaded-files" *ngIf="forwardUploadedFiles.length > 0">
                <div *ngFor="let file of forwardUploadedFiles; let i = index" class="file-item">
                  <mat-icon>insert_drive_file</mat-icon>
                  <span>{{ file.name }}</span>
                  <mat-icon class="remove-icon" style="cursor: pointer;" (click)="removeForwardFile(i)">close</mat-icon>
                </div>
              </div> -->

              <div class="actions d-flex justify-content-end" style="margin-top: 13px;">
                <button mat-flat-button color="primary" (click)="sendForward()">
                  <span>Forward</span>
                  <mat-icon style="margin-left: 8px;">send</mat-icon>
                </button>
              </div>
            <!-- </div> -->
          </form>
        </div>
      </div>
    </div>

    <!-- Mail Header and Thread -->
    <div class="du-mail-header-container">
      <div class="du-mail-header-left">
        <mat-icon class="du-mail-avatar-icon">account_circle</mat-icon>
        <div class="du-mail-user-info">
          <div *ngIf="emailService.isSentTabSelected; else showFrom">
            <div class="du-mail-name">{{ emailDetails?.to || 'Unknown Recipient' }}</div>
            <div class="du-mail-email">{{ emailDetails?.toEmail || '' }}</div>
          </div>
          <ng-template #showFrom>
            <div class="du-mail-name">{{ emailDetails?.from || 'Unknown Sender' }}</div>
            <div class="du-mail-email">{{ emailDetails?.fromEmail || '' }}</div>
          </ng-template>
        </div>
      </div>
      <div class="du-mail-header-right">
        <span class="du-mail-time">{{ emailDetails?.receivedDateTime | date: 'hh:mm a | dd.MM.yy' }}</span>
        <button class="du-mail-action-btn reply-btn" (click)="toggleReplySection()"><i
            class="material-icons reply-icon">reply</i> Reply</button>
        <button class="du-mail-action-btn forward-btn" (click)="toggleForwardSection()"><i
            class="material-icons forward-icon">forward</i>Forward</button>
      </div>
    </div>

    <div class="subject-value">{{ emailDetails?.subject || 'No Subject' }}</div>

    <!-- Conversation Thread -->
    <div class="conversation-thread-container">
      <div class="conversation-thread">
        <div *ngFor="let message of conversationThread; let i = index; trackBy: trackByMessageId"
          class="conversation-message">
          <!-- Attachments -->
          <div *ngIf="message.attachments?.length > 0" class="attachments-list">
            <div *ngFor="let attachment of message.attachments" class="attachment-item">
              <mat-icon>{{ getFileIcon(attachment.contentType) }}</mat-icon>
              <a [href]="'data:' + attachment.contentType + ';base64,' + attachment.contentBytes" target="_blank"
                download="{{ attachment.name }}">{{ attachment.name }}</a>
            </div>
          </div>

          <!-- Body with inline image rendering -->
          <div class="message-body" [innerHTML]="message.sanitizedBody"></div>

        </div>
      </div>
    </div>

  </div>
</div>